<template>
  <v-dialog v-model="dialog" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown" persistent>
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase">
        Chuyển đăng ký
        <v-spacer />
        <v-icon color="white" @click="close">mdi-close</v-icon>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-5">
        <div class="d-flex">
          <div class="mr-10">
            <p class="mb-0">Hồ sơ</p>
            <div>{{ $_get(item, 'cv.code') }} - {{ $_get(item, 'cv.name') }}</div>
          </div>
        </div>
        <div>
          <span>Slot hiện tại</span>
        </div>
        <v-form ref="form">
          <v-row no-gutters>
            <v-col cols="5" class="d-flex justify-start align-start font-weight-medium">
              {{ $_get(item, 'eventSlot.title') }}
            </v-col>
            <v-col cols="1" class="d-flex justify-center align-start">
              <v-icon large>mdi-arrow-right</v-icon>
            </v-col>
            <v-col cols="6" class="py-0 d-flex justify-center align-start mr-0">
              <v-autocomplete
                :items="eventSlots"
                item-text="title"
                item-value="id"
                v-model="slot"
                outlined
                dense
                :rules="[$rules.required]"
                label="Chọn Slot"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-text>
        <div>
          <span style="color: red">*</span> Học sinh chỉ có thể chuyển đăng ký sang Slot khác nếu Slot đó còn chỗ trống.
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined class="grey--text" @click="close">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="onSave">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
// import CardStudentName from '@/components/basic/card/CardStudentName.vue'

export default {
  // components: { CardStudentName },
  data: () => ({dialog: false, item: null, id: '', slot: ''}),
  computed: {
    ...mapGetters({
      eventSlots: 'eventSlots/getItems',
    }),
  },
  methods: {
    ...mapActions({
      changeSlot: 'eventSlotStudents/changeSlot',
    }),
    init(item = {}) {
      this.item = item
      this.id = item.id
    },
    open(item) {
      this.init(item)
      this.dialog = true
    },
    close() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async onSave() {
      const isValid = this.$refs.form.validate()
      if (!isValid) return this.$alert.error('Vui lòng chọn Workshop cần thay đổi')
      try {
        this.$loading.active = true
        await this.changeSlot({id: this.id, slot: this.slot})
        this.$alert.success('Chuyển đăng ký thành công')
        this.close()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>
